module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "index"
  }, [_c('div', {
    staticClass: "side"
  }, [_c('h1', {
    attrs: {
      "title": "vue backend library"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("<vbl/>")])], 1), _c('h2', [_c('vbl-icon', {
    attrs: {
      "type": "ion-android-arrow-dropright"
    }
  }), _vm._v("常用")], 1), _c('ul', _vm._l((_vm.common), function(plugin, name) {
    return _c('li', {
      class: {
        'active': _vm.currentView === name
      }
    }, [_c('router-link', {
      attrs: {
        "to": ("/" + name)
      }
    }, [_vm._v(_vm._s(name))])], 1)
  })), _c('h2', [_c('vbl-icon', {
    attrs: {
      "type": "ion-android-arrow-dropright"
    }
  }), _vm._v("基本")], 1), _c('ul', _vm._l((_vm.basic), function(plugin, name) {
    return _c('li', {
      class: {
        'active': _vm.currentView === name
      }
    }, [_c('router-link', {
      attrs: {
        "to": ("/" + name)
      }
    }, [_vm._v(_vm._s(name))])], 1)
  })), _c('h2', [_c('vbl-icon', {
    attrs: {
      "type": "ion-android-arrow-dropright"
    }
  }), _vm._v("浮层")], 1), _c('ul', _vm._l((_vm.float), function(plugin, name) {
    return _c('li', {
      class: {
        'active': _vm.currentView === name
      }
    }, [_c('router-link', {
      attrs: {
        "to": ("/" + name)
      }
    }, [_vm._v(_vm._s(name))])], 1)
  })), _c('h2', [_c('vbl-icon', {
    attrs: {
      "type": "ion-android-arrow-dropright"
    }
  }), _vm._v("表单")], 1), _c('ul', _vm._l((_vm.form), function(plugin, name) {
    return _c('li', {
      class: {
        'active': _vm.currentView === name
      }
    }, [_c('router-link', {
      attrs: {
        "to": ("/" + name)
      }
    }, [_vm._v(_vm._s(name))])], 1)
  }))]), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "example"
  }, [_vm._m(0), _c('div', {
    staticClass: "demo"
  }, [_c(_vm.demo, {
    tag: "component"
  })], 1), _c('div', {
    staticClass: "readme"
  }, [_c('pre', [_vm._v(_vm._s(_vm.code))])])]), _c('div', {
    staticClass: "readme",
    domProps: {
      "innerHTML": _vm._s(_vm.doc)
    }
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "readme"
  }, [_c('h2', [_vm._v("Examples")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4c75808e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./docs-src/index.vue
// module id = 264
// module chunks = 0